(function() {
  'use strict';

  function DashboardTemplateController(
    $rootScope,
    RouterHelper,
    DashboardTemplates,
    DashboardTemplatesUtils,
    Utils,
    Auth,
    Notify,
    Router,
    FeatureService
  ) {
    var ctrl = this;

    /**
     * Filter the widgets and only allow certain widgets to be added.
     * This function is run by the adf-dashboard framework for every
     * widget in the colleciton.
     * @param  {Object} widget The widget object.
     * @param  {string} type   The type of the widget. This is set up when creating
     *                         the widget.
     * @return {Boolean}       Whether to allow the widget or not.
     */
    ctrl.filterWidgets = function(_widget, type) {
      var disallowedWidgets = ['eventDrafts'];

      var reportingEnabled = FeatureService.enabledFeatures().some(function(f) {
        return f.id === 'reporting';
      });
      if (!reportingEnabled) {
        disallowedWidgets.push('SQLReportWidget');
      }

      return !_.includes(disallowedWidgets, type);
    };

    /**
     * Listen for changes to the widgets
     */
    $rootScope.$on('adfWidgetReloaded', function(_event, widget) {
      Notify.success('Dashboard widget reloaded.', widget?.title || 'Success');
    });

    $rootScope.$on('adfWidgetConfigChanged', function(_event, widget) {
      Notify.success('Dashboard widget configuration saved.', widget?.title || 'Success');
    });

    $rootScope.$on('adfWidgetRemoved', function(_event, widget) {
      Notify.success('Dashboard widget removed.', widget?.title || 'Success');
    });

    $rootScope.$on('adfWidgetAdded', function(_event, widget) {
      Notify.success('Dashboard widget added.', widget?.title || 'Success');
    });

    /**
     * Listen for changes coming in from the form and update the dashboard adf-model as needed.
     */
    $rootScope.$on('KZTemplate:FormChanged', function(_evt, args) {
      ctrl.template.template = _.assign(
        {},
        ctrl.template.template,
        args
      );
    });

    /**
     * Set the dashboard template and the workable template object.
     * @param  {Object} data The object to base the template on.
     * @return {Object}      The extended dashboard template.
     */
    var setDashboardTemplate = function(data) {
      ctrl.template = DashboardTemplatesUtils.extendTemplate(data, ctrl.org);
      // This hides the title just for the editing interface
      ctrl.template.template.options.hideTitle = true;
      return ctrl.template;
    };

    /**
     * Save the dashboard template.
     * This also saves the audit log.
     * @param  {Object}  doc The template to save.
     * @param  {String}  msg The message to display to the user when the save is complete.
     * @return {Promise}     A promise for chaining.
     */
    var saveDashboardTemplate = function(doc, msg) {
      return DashboardTemplatesUtils
              .saveAuditLog(doc, ctrl.isNew || ctrl.isEditingCopy, Auth.currentUser())
              .then(function(doc) {
                doc.template = _.pick(doc.template, ['structure', 'rows', 'title']);
                return DashboardTemplates.save(doc);
              })
              .then(function() {
                Notify.success(msg, 'Success');
                Router.navigate(['/dashboard-templates']);
              })
              .catch(Utils.showError);
    };

    /**
     * Form validations.
     * We cannot use form.$invalid because the dashboard template
     * can contain nested forms and the validation will only pass
     * if all the nested forms are also valid.
     * @return {Boolean} Whether the form has errors or not.
     */
    var validateForm = function() {
      var errors = [],
          hasError = false;

      // At the moment, only the title is required
      if (_.isUndefined(ctrl.template.title) || ctrl.template.title === '') {
        hasError = true;
        errors.push('Please make sure the dashboard has a title!');
      }

      if (hasError) {
        Utils.swal({
          title: errors.join('\n'),
          type: 'error'
        });

        return false;
      }

      return !hasError;
    };


    ctrl.$onInit = function() {
      ctrl.org = Auth.currentOrganisation();
      ctrl.isNew = _.isUndefined(ctrl.id);
      ctrl.templateType = 'dashboard';
      ctrl.template = RouterHelper.popState().template;
      ctrl.isEditingCopy = !_.isUndefined(ctrl.template);

      setDashboardTemplate(ctrl.template || {});

      // If we are editing, let's load the template
      if (ctrl.id) {
        DashboardTemplates.find(ctrl.id)
          .then(function(data) {
            Utils.setPageTitle('Edit dashboard template: ' + data.template.title);
            return setDashboardTemplate(data);
          })
          .then(function() {
            ctrl.loaded = true;
          })
          .catch(Utils.showError);
      } else {
        Utils.setPageTitle('New dashboard template');
        ctrl.loaded = true;
      }
      ctrl.canRemoveDefault = false;

      DashboardTemplatesUtils.canRemoveDefaultDashboardTemplate()
        .then(function(res) {
          ctrl.canRemoveDefault = res === undefined ? true : res;
        });
    };


    /**
     * Handles the user click on Save.
     * @param  {Object} form The form object being saved.
     * @return {void}
     */
    ctrl.save = function(form) {
      form.$setSubmitted();

      if (!validateForm()) {
        return;
      }

      saveDashboardTemplate(ctrl.template, 'Dashboard template successfully saved!');
    };

    /**
     * Handle the user click on Delete.
     * @return {void}
     */
    ctrl.remove = function() {
      var opts = {
        title: 'Are you sure you want to remove this dashboard template?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      };

      // If the dashboard is the default, we schange the message being displayed
      if (ctrl.template.isDefault) {
        opts.text = 'This is the default dashboard. Removing this dashboard ' +
                    'template will only recreate it automatically for you, ' +
                    'but you would lose all the changes you\'ve made!';
      }

      Utils.swal(
        opts,
        function(isConfirm) {
          if (isConfirm) {
            DashboardTemplates.remove(ctrl.id)
              .then(function() {
                Notify.success('Dashboard template successfully removed!', 'Success');
                Router.navigate(['/dashboard-templates']);
              })
              .catch(Utils.showError);
          }
        }
      );
    };
  }

  DashboardTemplateController.$inject = [
    '$rootScope',
    'RouterHelperService',
    'DashboardTemplatesService',
    'DashboardTemplatesUtilsService',
    'UtilsService',
    'AuthService',
    'NotifyService',
    'Router',
    'FeaturesService'
  ];

  angular.module('component.dashboardTemplates')
    .controller('DashboardTemplateController', DashboardTemplateController);
})();
